<div class="container" [ngClass]="bannerNotification.background_colour">
    <div class="content">
        {{ bannerNotification.content }}
    </div>
    <div class="close" (click)="close()">
        <app-centrui-button-icon [buttonStyle]="'large dark'" [icon]="'new/cancel-01.svg'"></app-centrui-button-icon>
    </div>
</div>
